///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../../../baseClasses/dataMaintenance.interface.ts"/>
///<reference path="../../../../plugins/reports/reports.models.ts"/>
///<reference path="../common/collection-api.ts"/>


module Meevo.Components.Controls.SmartMover {
    import IReportManufacturers = Meevo.Plugins.Reports.IReportManufacturers;

    export class InventoryManufacturersCollection extends SmartMoverApiCollection<IReportManufacturers> implements IApiCollection<IReportManufacturers> {

        protected get url() {
            return 'Report/Manufacturer';
        }
    }

}